<template>
  <v-menu
    offset-y
    left
    transition="slide-y-transition"
    :close-on-content-click="false"
  >
    <template #activator="{ on }">
      <v-badge
        bordered
        :content="notificationsCount"
        color="red"
        offset-x="22"
        offset-y="22"
        :value="notificationsCount >= 1"
      >
        <v-btn
          icon
          v-on="on"
        >
          <v-icon>mdi-bell-outline</v-icon>
        </v-btn>
      </v-badge>
    </template>

    <!-- dropdown card -->
    <v-card
      max-height="600px"
      class="overflow-y-auto"
    >
      <v-list
        three-line
        dense
        width="450px"
      >
        <v-subheader class="pa-2 font-weight-bold d-flex justify-space-between">
          <div>Úiltimas notificaciones</div>
          <div>
            <v-chip
              :color="notificationFiler === 'all' ? '#fad4b9': 'white'"
              @click.stop="notificationFiler = 'all'"
            >
              <span :style="notificationFiler === 'all' ? 'color: #ee7f2d;': 'color: black;'">Todas</span>
            </v-chip>
            <v-chip
              :color="notificationFiler === 'notReaded' ? '#fad4b9': 'white'"
              @click.stop="notificationFiler = 'notReaded'"
            >
              <span :style="notificationFiler === 'notReaded' ? 'color: #ee7f2d;': 'color: black;'">No leídas</span>
            </v-chip>
          </div>

        </v-subheader>
        <template v-if="notifications.length > 0 && !isLoadingNotifications">
          <Notification
            v-for="(notification, index) in filteredNotifications"
            :key="notification.id"
            :notification="notification"
            :index="index"
            @setIsReadById="setIsReadById($event)"
            @openDialog="openDialog($event)"
            @router="$router.push($event)"
          />
        </template>
        <v-card
          v-else
          flat
          class="text-center"
        >No hay notificaciones nuevas</v-card>
      </v-list>
    </v-card>
    <v-dialog
      v-model="dialog"
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline" v-html="parsedTitle.html"></v-card-title>
        <v-card-text >
          <div v-html="parsedMessage.html"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-for="link in parsedMessage.links"
            :key="link.href"
            color="primary"
            text
            @click="openMarkdownLink(link.href)"
          >
            {{ link.text }}
          </v-btn>
          <v-btn color="primary" text @click="closeDialog">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-divider />
  </v-menu>
</template>

<script setup>
import { computed, getCurrentInstance, onMounted, ref, watch } from 'vue'
import Notification from './Notification.vue'
import { parseMarkdown } from '@/utils/markdownParser'

const instance = getCurrentInstance()
const state = instance?.proxy?.$store?.state
const emit = defineEmits(['showNotification', 'openDialog', 'userNotifications'])

const isLoadingNotifications = computed(() => state?.general.isLoadingNotifications)
const notifications = computed(() => state?.general.notifications)

const dialog = ref(false)
const selectedNotification = ref({ message: '' })
const parsedMessage = ref({ html: '', links: [] })
const parsedTitle = ref({ html: '', links: [] })

onMounted(() => {
  if (instance.proxy.$route.fullPath === '/testing') return
})

const notificationFiler = ref('all')
const filteredNotifications = computed(() =>
  notificationFiler.value === 'all'
    ? notifications.value
    : notifications.value.filter((n) => n.is_read === 0)
)

const setIsReadById = ({ user_notification_id, newReadStatus }) => {
  const index = notifications.value.findIndex((n) => n.user_notification_id === user_notification_id)
  if (index !== -1) notifications.value[index].is_read = newReadStatus
}

const openDialog = (notification) => {
  selectedNotification.value = notification
  parsedMessage.value = parseMarkdown(notification.message, { preview: false })
  dialog.value = true
}
const closeDialog = () => (dialog.value = false)

const notificationsCount = computed(() =>
  notifications.value.filter((n) => n.is_read === 0).length
)

const openMarkdownLink = (url) => {
  emit('markdown-btn-click', url)
}
watch(() => selectedNotification.value, (newVal) => {
  parsedMessage.value = parseMarkdown(newVal.message, { preview: false })
})
watch(
  () => selectedNotification.value,
  (newVal) => {
    if (!newVal) return
    parsedMessage.value = parseMarkdown(newVal.message, { preview: false })
    parsedTitle.value = parseMarkdown(newVal.title || '', { preview: false })
  },
  { immediate: true }
)
</script>
